import { Play } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function YourJourneyStartsHere() {
  return <section data-section-id="224922" id="monitoraggio-e-sicurezza-h24" className="bg-background text-foreground relative min-h-[80vh] flex items-center justify-center overflow-hidden py-24 lg:py-32">
      {}
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-cover bg-center bg-[url('https://wpvc-images.s3.us-east-1.amazonaws.com/images/1666921/img/high_tech_security_sensor.png')]" />
        {}
        <div className="absolute inset-0 bg-gradient-to-b from-background/60 via-background/80 to-background" />
      </div>

      {}
      <div className="container relative z-10 mx-auto px-4 text-center">
        <h1 className="font-default text-5xl md:text-6xl lg:text-[72px] leading-tight font-bold mb-6 text-foreground tracking-tighter">
          Protezione Totale, 24/7
        </h1>
        
        <p className="font-default text-xl md:text-2xl mb-12 text-muted-foreground max-w-3xl mx-auto font-light">
          Sistema monitorato costantemente e collegato direttamente alle Forze dell'Ordine o vigilanza privata.
        </p>

        {}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-6">
          <Button asChild size="lg" className="w-full sm:w-auto bg-primary text-primary-foreground font-semibold h-14 px-8 text-lg rounded-lg shadow-lg shadow-primary/20 transition-transform hover:scale-105">
            <Link to="#">Inizia ora</Link>
          </Button>
          
          <Button asChild size="lg" variant="outline" className="w-full sm:w-auto gap-2 h-14 px-8 text-lg rounded-lg border-2 border-foreground bg-transparent hover:bg-foreground/10 text-foreground transition-transform hover:scale-105">
            <Link to="#">
              <Play className="w-5 h-5 fill-current" />
              Parla con un esperto
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}